// export class PendingRequest {

//     senderId:string;
//     sub:Subject[];
//     body:string;
//     date_time: string;
//     spec: Specification[];
//     amount: number;
//     remark: Remark[];
//     attachment: Attachment[];
//     hide: boolean;
//     star: boolean;


//     // appEmailId: number;
//     // senderID: string;
//     // ccId: string;
//     // toId: string;
//     // body: string;
//     // date_time: string;
//     // amount: number;
//     // hide: boolean;
//     // star: boolean;
//     // deleted: boolean;
//     // extra1: string;
//     // extra2: string;
//     // createdOn: string;
//     // updatedOn: string;
//     // email_Id: number;
//     // user_id: number;
//     // attachment: Attachment[];
//     // sub: Subject[];
//     // spec: Specification[];
//     // remark: Remark[];
// }

export class PendingRequest {
    emailData_Id: number;
    senderId: string;
    ccId: string;
    toId: string;
    subject: string;
    body: string;
    dateTime: string;
    createdOn: string;
    updatedOn: string;
    status: string;
    user_id: number;
    hide: boolean;
    star: boolean;
    sub:Sub[];
    spec: Specification[];
    amount: number;
    remark: Remark[];
    attachment: Attachment[];
}

export class Attachment {
    fileId: number;
    fileType: string;
    fileSize: number;
    filePath: string;
    user_id: number;
    fileName:string;
}

export class Sub {
    subjectId:number;
    name: string;
    //descrition: string;
}

export class Specification {
    specificationId:number;
    name: string;
    //descrition: string;
}

export class Remark {
    remarkId:number;
    name: string;
    //descrition: string;
}



